export default __webpack_public_path__ + "static/media/interpretation_disabled.8253bc13.svg";